import React, { type FC } from 'react'
import { type FeedData } from 'pages/native/userFeed/types'

import classes from './FooterInfo.module.scss'
import { AddressBadge } from '../../../badges/AddressBadge/AddressBadge'
import { PlanedBadge } from '../../../badges/PlanedBadge/PlanedBadge'
import { ReplyBadge } from '../../../badges/ReplyBadge/ReplyBadge'

type FooterInfoProps = {
  game: FeedData
}
export const FooterInfo: FC<FooterInfoProps> = ({ game }) => {
  const isReply = game.isReplay
  const isInFuture = new Date((+game.startTime || 0) * 1000) > new Date()

  if (!game.location.name && !isInFuture && !isReply) {
    return null
  }

  return (
    <div className={classes.Container}>
      {game.location.name ? (
        <AddressBadge address={game.location.name} />
      ) : (
        <span></span>
      )}

      <div className={classes.Badges}>
        {isInFuture && <PlanedBadge />}
        {isReply && <ReplyBadge />}
      </div>
    </div>
  )
}
